import { useTranslation } from "react-i18next";
import WasteFlowUnauthorizedCell from "./WasteFlowUnauthorizedCell";
import { formatDensity, formatTreatmentCost } from "./wasteFlowUtils";

const WasteFlowRow = ({ data, onOpen }) => {
  const { t } = useTranslation();
  const handleRowClick = () => {
    if (data?._id) onOpen(data);
  };

  return (
    <article
      className="table-standard-row table-standard-row--clickable"
      onClick={handleRowClick}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          handleRowClick();
        }
      }}
    >
      <div className="table-standard-row-cell">
        <span className="waste-flow-row__label">{data.label || "—"}</span>
      </div>
      <div className="table-standard-row-cell">
        <span>{formatDensity(data)}</span>
      </div>
      <div className="table-standard-row-cell">
        <span>
          {formatTreatmentCost(data, t("settingsWaste.treatmentCostPerTon"))}
        </span>
      </div>
      <div className="table-standard-row-cell waste-flow-row__unauthorized-col">
        <WasteFlowUnauthorizedCell waste={data} streamType="pro" />
      </div>
    </article>
  );
};

export default WasteFlowRow;
